module.exports = __webpack_public_path__ + "img/symbol_15.28a18e0e.png";